import {Dispatch} from 'react'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {KEYS} from '../../constants/keysStorage'
import {generalOpenModalError, generalShowLoader} from '../general.actions'
import {getDatosEmisor, invalidarDatosEmisor} from '../catalogos.actions'
import {
  AlistamientoNormativa,
  RequisitoAlistamiento,
  ResultadoCambioVersion,
} from '../../interfaces/normativa.interface'

const MENSAJE_ERROR_ALISTAMIENTO =
  'No se logró consultar el alistamiento de su empresa para la normativa 2.0.'

const MENSAJE_ERROR_CAMBIO = 'No se logró cambiar la versión de la normativa.'

const LARGO_MAXIMO_OBSERVACION = 500

export const normativaGetAlistamiento =
  () =>
  async (dispatch: Dispatch<any>): Promise<AlistamientoNormativa | null> => {
    dispatch(generalShowLoader(true))
    return await http
      .get(ENDPOINTS.NORMATIVA_GET_ALISTAMIENTO, {}, KEYS.TOKEN)
      .then((res: any) => (res?.data as AlistamientoNormativa) ?? null)
      .catch((err: any) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? MENSAJE_ERROR_ALISTAMIENTO,
            err?.response?.data?.status
          )
        )
        return null
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const normativaCambiarVersion =
  (version: string, observacion: string = '') =>
  async (dispatch: Dispatch<any>): Promise<ResultadoCambioVersion> => {
    dispatch(generalShowLoader(true))

    const detalle = observacion.trim().substring(0, LARGO_MAXIMO_OBSERVACION)
    const cuerpo = {version, ...(detalle ? {observacion: detalle} : {})}

    return await http
      .post(ENDPOINTS.NORMATIVA_POST_CAMBIAR_VERSION, cuerpo, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        invalidarDatosEmisor()
        await dispatch(getDatosEmisor(true))

        return {
          exitoso: true,
          mensaje: res?.message ?? 'La versión de la normativa quedó actualizada.',
          cambio: res?.data ?? null,
          requisitos: [] as Array<RequisitoAlistamiento>,
        }
      })
      .catch((err: any) => ({
        exitoso: false,
        mensaje: err?.response?.data?.message ?? MENSAJE_ERROR_CAMBIO,
        cambio: null,
        requisitos: (err?.response?.data?.data?.requisitos as Array<RequisitoAlistamiento>) ?? [],
      }))
      .finally(() => dispatch(generalShowLoader(false)))
  }
